export default {
  setup: null,
  faqs: []
};
